import { styled } from '@sds-system/system';
import type { AllStyledProps } from '@sds-system/types';
import { getAllStyledProps } from '@sds-system/utils';

export const SpinnerRoot = styled('div')<AllStyledProps>(() => {
  return {};
}, getAllStyledProps);
